import { Suspense, lazy } from 'react';
import type { ReferenceProjectsPickerProps } from './ReferenceProjectsPicker';

/**
 * Defers loading the picker — and with it Apollo, the identity context, and date-fns — until the
 * customer actually reaches the project-selection step.
 *
 * Load-bearing, not an optimisation: the picker is the one place in this library that reaches for
 * those dependencies (see the KNOWN EXCEPTION note in ../types.ts), so splitting it here keeps
 * every other consumer of ChatInterface free of them.
 */
const Picker = lazy(async () => {
    const module = await import('./ReferenceProjectsPicker');

    return { default: module.ReferenceProjectsPicker };
});

export function ReferenceProjectsPicker(props: ReferenceProjectsPickerProps) {
    // `null` rather than a spinner: the wizard step already reports its loading state through
    // WizardStep's `isReady`, and a second indicator inside the step would double it up.
    return (
        <Suspense fallback={null}>
            <Picker {...props} />
        </Suspense>
    );
}

export type { ReferenceProjectsPickerProps };
